import { Card } from "antd";
import styled from "styled-components";
import { ContainerWrapper } from "../../../../app/app.style";

type StyledPromptType = {
  $visible: boolean;
  $color: string;
};

type StyledDivWrapperType = {
  $elLength: number;
};

export const StyledPrompt = styled.span<StyledPromptType>`
  position: absolute;
  bottom: 5px;
  left: 0;
  font-weight: 600;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  color: ${({ $color }) => $color};
`;

export const StyledContainerForm = styled.div`
  display: flex;
  flex-direction: row;
  gap: var(--spacing-md);
  background-color: rgba(255,255,255,0.4);
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  padding: var(--spacing-md);
  border-radius: 6px;
  width: 80%;
`;

export const StyledCardPrompt = styled(Card)`
  border: 1px solid #d9d9d9;
  color: rgba(0, 0, 0, 0.25);
  font-weight: 500;
`;

export const StyledDivWrapper = styled.div<StyledDivWrapperType>`
  display: flex;
  align-items: center;
  background-color: white;
  padding: var(--spacing-xs);
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  justify-content: ${({ $elLength }) =>
    $elLength ? "space-between " : "flex-end"};
`;

export const OverriddenContainerWrapper = styled(ContainerWrapper)`
  position:relative;
  justify-content: center;
  align-items: center;
  background: linear-gradient(180deg, #FAFBFF 0%, #FFFFFF 25%, #F3F6FF 70%, #EEF2FF 110%)
`;
